<template>
    <div class="audio" v-if="display">
      <div class="audio_main" v-if="available">
        <div class="audio_close" @click="closeAudior">X</div>
        <div class="audio_button" @click="audioBtn">
          <i class="el-icon-microphone" v-if="!parsing && !recording"></i>
          <i class="el-icon-more" v-if="!parsing && recording && recordstat"></i>
          <i class="el-icon-more-outline" v-if="!parsing && recording && !recordstat"></i>
          <i class="el-icon-loading" v-if="parsing"></i>
        </div>
      </div>
      <div class="audio_main" v-if="!available">
        <div class="audio_close" @click="closeAudior">X</div>
        <div class="audio_button">
          <i class="el-icon-turn-off-microphone"></i>
        </div>
      </div>
    </div>
</template>

<script>
  import { uploadFile } from '../api/api';
  let rsinterval = null;
    export default {
      name: "audior",
      data(){
        return {
          display:false,
          available:false,
          recording:false,
          recordstat:false,
          parsing:false,
          audioRecorder: null,
          order_id:null,
          timeout:0
        }
      },
      mounted(){
        if(this.audioRecorder==null){
          navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;
          if(navigator.mediaDevices){
            this.available = true;
            navigator.mediaDevices.getUserMedia({audio:true}).then((stream) => {
              this.audioRecorder = new MediaRecorder(stream);
              this.audioRecorder.addEventListener("dataavailable",(event)=>{
                let audioBlob = new Blob([event.data], { type: "audio/wav" });
                let file = new File([audioBlob], (new Date().valueOf())+'.wav', {
                  type: audioBlob.type,
                  lastModified: Date.now()
                });
                let params = new FormData();
                params.append('files',file);
                this.parsing = true;
                uploadFile(params).then(res => {
                  if(res && res.status === 0){
                    if(res.data!=null && res.data.length>0){
                      let data = JSON.parse(JSON.stringify(res.data[0]));
                      if(parseInt(data.status) === 0){
                        if(data['message']) delete data['message'];
                        if(data['status'] || data['status']===0) delete data['status'];
                        this.audioResult(data);
                        this.display = false;
                      }else{
                        this.$alert(data.message,'错误提示',{
                          center:true,
                          type:'error',
                          confirmButtonText: '确定',
                          callback: action => {

                          }
                        });
                      }
                    }else{
                      this.$alert(res.message,'错误提示',{
                        center:true,
                        type:'error',
                        confirmButtonText: '确定',
                        callback: action => {

                        }
                      });
                    }
                  }else{
                    this.$alert(res.message,'错误提示',{
                      center:true,
                      type:'error',
                      confirmButtonText: '确定',
                      callback: action => {

                      }
                    });
                  }
                }).catch(e => {
                  this.$alert(e.message,'错误提示',{
                    center:true,
                    type:'error',
                    confirmButtonText: '确定',
                    callback: action => {

                    }
                  });
                }).finally(f => {
                  this.parsing = false;
                  this.recording = false;
                });
              })
            }).catch(e => {
              console.log(e);
            })
          }else{
            this.available = false;
          }
        }
        if(rsinterval==null ) rsinterval = setInterval(()=> {
          this.recordstat = !this.recordstat;
        },1000)
      },
      beforeDestroy(){
        this.audioRecorder = null;
        this.recording = false;
      },
      methods:{
        openAudior(){
          this.display = true;
        },
        closeAudior(){
          if(this.recording) this.stopRecording();
          this.display = false;
        },
        audioBtn(){
          if(!this.recording){
            this.startRecording();
          }else{
            this.stopRecording();
          }
        },
        startRecording() {
          this.recording = true;
          this.audioRecorder.start();
        },
        stopRecording() {
          this.recording = false;
          this.audioRecorder.stop();
        },
        audioResult(datas){
          this.$emit('audioResult',datas);
        }
      }
    }
</script>

<style scoped>
  .audio {
    position:absolute;
    top:0;
    left:0;
    display: inline-block;
    width:100%;
    height:93.5vh;
    background-color:rgba(0,0,0,0.9);
    z-index:99;
    overflow-y:hidden;
  }
  .audio_main {
    position:absolute;
    bottom:0;
    left:0;
    width:100%;
    height:40vh;
    background-color:rgba(255,255,255,1);
  }
  .audio_button {
    width:12rem;
    height:30vh;
    margin:5vh auto;
    line-height:30vh;
    text-align:center;
    font-size:6rem;
    border:2px solid #3a8ee6;
    color:#3a8ee6;
    border-radius:15vh;
  }
  .audio_close {
    position:absolute;
    bottom:34vh;
    right:.4rem;
    width:2rem;
    height:2rem;
    line-height:2rem;
    font-size:1.2rem;
    text-align:center;
    cursor:pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/audior.vue